import styled from 'styled-components';

export const PlaystoreContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.landing ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)'};
  // align-items: center;
  column-gap: ${(props) => props.gap};
  padding: ${(props) => (props.playstore ? '2em 0' : '1em 0')};

  @media (max-width: 720px) {
    grid-template-columns: ${(props) =>
      props.companion ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)'};
    row-gap: 16px;
    padding: 1em 0;
  }
  & div {
    text-align: center;
  }
`;

export const Rating = styled.p`
  font-size: calc(1em + 1vw);
  font-weight: 600;

  & img {
    width: 20px;
    height: 20px;
    @media (max-width: 720px) {
      width: 14px;
      height: 14px;
    }
  }
`;

export const RatingName = styled.p`
  font-size: 10px;
  font-weight: 500;
  color: #0000004f;
`;
